module.exports = __webpack_public_path__ + "static/Hey-925545faa42148ddda0199cc60b83ab7.png";